import React, { useState } from "react";
import { Steps, Typography, Button } from "antd";
import StepOne, { StepOneData } from "./StepOne";
import StepTwo, { StepTwoData } from "./StepTwo";
import StepThree from "./StepThree";
import ResultStep from "./ResultStep";
import { useLocation, useNavigate } from "react-router-dom";

const { Title } = Typography;

const CreateBidOptimizer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [current, setCurrent] = useState(location?.state?.step || 0);
  const [stepOneData, setStepOneData] = useState<StepOneData | null>(null);
  const [stepTwoData, setStepTwoData] = useState<StepTwoData | null>(null);
  const [jobName, setJobName] = useState<string>(location?.state?.jobName || "");
  const [jobConfigId, setJobConfigId] = useState<string>(
    location?.state?.jobConfigId || ""
  );

  // Define step content based on current state
  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <StepOne
            onNext={(data) => {
              setStepOneData(data);
              setCurrent(1);
            }}
            existingData={stepOneData}
          />
        );
      case 1:
        return stepOneData ? (
          <StepTwo
            stepOneData={stepOneData}
            onNext={(data) => {
              setStepTwoData(data);
              setCurrent(2);
            }}
            onPrevious={() => setCurrent(0)}
            onNameChange={(name) => setJobName(name)}
          />
        ) : (
          <div className="text-center p-8">
            <Title level={4} className="text-gray-500">
              Please complete step 1 first
            </Title>
          </div>
        );
      case 2:
        return stepOneData && stepTwoData ? (
          <StepThree
            stepOneData={stepOneData}
            stepTwoData={stepTwoData}
            onPrevious={() => setCurrent(1)}
            onNext={(configId) => {
              setJobConfigId(configId);
              setCurrent(3);
            }}
          />
        ) : (
          <div className="text-center p-8">
            <Title level={4} className="text-gray-500">
              Please complete previous steps first
            </Title>
          </div>
        );
      case 3:
        return jobConfigId ? (
          <ResultStep
            jobConfigId={jobConfigId}
            onPrevious={() => setCurrent(2)}
          />
        ) : (
          <div className="text-center p-8">
            <Title level={4} className="text-gray-500">
              Please complete previous steps first
            </Title>
          </div>
        );
      default:
        return null;
    }
  };

  const steps = [
    {
      title: "Upload data",
      description: "Historic data upload",
    },
    {
      title: "Finalize dependent Variables",
      description: "Take informed decision using various data points",
    },
    {
      title: "Review and Submit",
      description: "Confirm and create job",
    },
    {
      title: "Results",
      description: "View and apply bid optimization results",
    },
  ];

  return (
    <div className="w-full h-[calc(100vh-75px)] flex flex-col bg-white rounded-lg shadow-sm overflow-hidden">
      <div className="flex flex-1 h-full overflow-hidden">
        <div className="max-h-[calc(100vh)] overflow-y-auto w-1/4 px-8 py-4  bg-gray-50 border-r">
          <div className=" pb-1 pt-2 bg-gray-50 mb-4 px-4">
            <h2
              title={jobName || "Bid Optimizer Test"}
              className="text-2xl font-semibold text-gray-900 max-w-[350px] truncate"
            >
              {jobName || "Bid Optimizer Test"}
            </h2>
          </div>
          <Steps
            direction="vertical"
            current={current}
            items={steps.map((step, index) => ({
              title: step.title,
              description: step.description,
              disabled: true,
              status:
                index < current
                  ? "finish"
                  : index === current
                    ? "process"
                    : "wait",
            }))}
            className="[&_.ant-steps-item]:mb-16 [&_.ant-steps-item-tail]:!top-3 [&_.ant-steps-item-tail]:!h-[110px] [&_.ant-steps-item-tail]:!w-[4px] [&_.ant-steps-item-icon]:!text-2xl [&_.ant-steps-item-icon]:!w-10 [&_.ant-steps-item-icon]:!h-10 [&_.ant-steps-item-icon]:!font-bold [&_.ant-steps-item-icon]:!flex [&_.ant-steps-item-icon]:!items-center [&_.ant-steps-item-icon]:!justify-center [&_.ant-steps-item-title]:!font-medium [&_.ant-steps-item-title]:!text-base"
          />
        </div>
        <div className="w-3/4 overflow-y-auto px-10 py-7 pb-24">
          {getStepContent(current)}
        </div>
      </div>
      {current === 3 && (
        <div className="flex justify-end items-center bg-white border-t p-4">
          <Button
            type="primary"
            size="large"
            onClick={() => navigate("/optimization/bid-optimizer")}
          >
            Finish
          </Button>
        </div>
      )}
    </div>
  );
};

export default CreateBidOptimizer;

// export default CreateBidOptimizer;
